import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["translatedText"]

  connect() {
    this.highlightClass = "highlight-reference"
    // Listen for the custom event
    document.addEventListener('translation-scroll:scrollToReference', this.scrollToReference.bind(this))
  }

  disconnect() {
    // Clean up event listener
    document.removeEventListener('translation-scroll:scrollToReference', this.scrollToReference.bind(this))
  }

  scrollToReference(event) {
    const referenceText = event.detail.reference
    if (!referenceText || !this.hasTranslatedTextTarget) return

    // Find the pre element containing the text
    const preElement = this.translatedTextTarget.querySelector('pre')
    if (!preElement) return

    const textContent = preElement.textContent
    const index = textContent.indexOf(referenceText)
    
    if (index === -1) return

    // Create a temporary marker element
    const marker = document.createElement('span')
    marker.className = this.highlightClass
    marker.textContent = referenceText

    // Split the text content
    const beforeText = textContent.substring(0, index)
    const afterText = textContent.substring(index + referenceText.length)

    // Update the pre content
    preElement.innerHTML = ''
    if (beforeText) preElement.appendChild(document.createTextNode(beforeText))
    preElement.appendChild(marker)
    if (afterText) preElement.appendChild(document.createTextNode(afterText))

    // Scroll the marker into view
    marker.scrollIntoView({ behavior: 'smooth', block: 'center' })

    // Remove highlight after delay
    setTimeout(() => {
      if (marker.parentNode) {
        const text = document.createTextNode(referenceText)
        marker.parentNode.replaceChild(text, marker)
      }
    }, 3000)
  }
}
